import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

const providerSlice = createSlice({
  name: "providers",
  initialState: {
    providers: [],
    rangeData: {},
  },
  reducers: {
    setProviders: (state, action) => {
      state.providers = action.payload;
    },
    setRangeData: (state, action) => {
      state.rangeData = action.payload;
    },
  },
});

export const { setProviders, setRangeData } = providerSlice.actions;
export default providerSlice.reducer;
